import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Luggage = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8 11.6538C5.78024 11.6538 3.98077 9.85437 3.98077 7.63461V6.17308H12.0192V7.63461C12.0192 9.85437 10.2198 11.6538 8 11.6538ZM8 11.6538V12.75M3.25 6.17308H12.75M5.44231 3.25L5.44231 6.17308M10.5577 3.25L10.5577 6.17308" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Luggage };